function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.007 29.463h15.568c2.777 0 4.216-1.44 4.216-4.178V9.641c0-2.751-1.44-4.178-4.216-4.178H10.007c-2.777 0-4.216 1.427-4.216 4.178v15.644c0 2.751 1.44 4.178 4.216 4.178zm4.793-6.016a1 1 0 0 1-1.118-1.015 1.365 1.365 0 0 1 .463-1l4.062-4.2c.823-.823 1.543-1.581 1.543-2.455a1.647 1.647 0 0 0-1.864-1.62 2.328 2.328 0 0 0-2.121 1.491 1.2 1.2 0 0 1-1.067.707.967.967 0 0 1-1.067-.99 2.024 2.024 0 0 1 .09-.6 4.229 4.229 0 0 1 4.139-2.622c2.558 0 4.242 1.375 4.242 3.432 0 1.427-.8 2.494-2.07 3.766l-2.815 2.957v.09h4.358a1.037 1.037 0 1 1 0 2.07z",
    transform: "translate(-5.791 -5.463)",
    style: {
      fill: "#1c1c1e"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.fda38580.svg";
export { ForwardRef as ReactComponent };